const COMMODORE_DATA = [
  {
    id: "vk",
    label: "VK Commodore (1984-1986)",
    variants: ["Sedan", "Calais", "Brock / HDT", "Modified / big brake"],
    pcd: "5x120",
    centreBore: "69.5 mm",
    factoryWheels: "14x6 to 15x7 depending model",
    factoryTyres: "205/65R15 reference starting point",
    offset: "Typically positive offset; confirm exact wheel width and brake package",
    nut: "M12x1.5 wheel nuts",
    notes: ["A 20-inch VK fitment must be checked for guard clearance, ride height and brake/suspension modifications.", "Confirm front and rear wheel widths before quoting; deep-dish and staggered setups require EA approval."]
  },
  {
    id: "vl",
    label: "VL Commodore (1986-1988)",
    variants: ["Sedan", "Wagon", "Calais", "Turbo / modified"],
    pcd: "5x120",
    centreBore: "69.5 mm",
    factoryWheels: "14x6 to 15x6",
    factoryTyres: "205/65R15",
    offset: "Approx +38 to +43",
    nut: "M12x1.5 wheel nuts",
    notes: ["Older guards and brake/suspension changes vary heavily.", "Drag style and deep dish setups need manual confirmation."]
  },
  {
    id: "vn-vs",
    label: "VN / VP / VR / VS Commodore (1988-1997)",
    variants: ["Sedan", "Wagon", "Ute", "Statesman/Caprice", "HSV"],
    pcd: "5x120",
    centreBore: "69.5 mm",
    factoryWheels: "15x6 to 17x8 depending variant",
    factoryTyres: "205/65R15 or 235/45R17",
    offset: "Approx +38 to +48",
    nut: "M12x1.5 wheel nuts",
    notes: ["Common street upgrades are 18 and 19 inch.", "Deep dish rear fitments depend on ride height, tyre width and guard work."]
  },
  {
    id: "vt-vz",
    label: "VT / VX / VY / VZ Commodore (1997-2006)",
    variants: ["Sedan", "Wagon", "Ute", "SS", "HSV / big brake"],
    pcd: "5x120",
    centreBore: "69.5 mm",
    factoryWheels: "15x7 to 19x8 depending variant",
    factoryTyres: "225/50R16, 235/45R17, 245/35R19",
    offset: "Commonly +38 to +48",
    nut: "M12x1.5 wheel nuts",
    notes: ["Very strong EA category for 19 and 20 inch HSV-style wheels.", "HSV brakes need spoke clearance, not only diameter clearance."]
  },
  {
    id: "ve",
    label: "VE Commodore (2006-2013)",
    variants: ["Omega/International", "SV6", "SS/SSV", "HSV E-Series", "Ute/Wagon"],
    pcd: "5x120",
    centreBore: "66.9 mm",
    factoryWheels: "16x7 to 20x8.5 depending variant",
    factoryTyres: "225/60R16, 245/45R18, 245/35R20",
    offset: "Commonly +35 to +48",
    nut: "M14x1.5 wheel nuts",
    notes: ["20 inch staggered fitments are common.", "22 inch show setups require tyre and clearance checks."]
  },
  {
    id: "vf",
    label: "VF Commodore (2013-2017)",
    variants: ["Evoke", "SV6", "SS/SSV Redline", "HSV Gen-F", "Ute/Wagon"],
    pcd: "5x120",
    centreBore: "66.9 mm",
    factoryWheels: "16x7 to 20x9.5 depending variant",
    factoryTyres: "245/40R19, 245/35R20, 275/30R20 rear HSV",
    offset: "Commonly +35 to +57 depending wheel width",
    nut: "M14x1.5 wheel nuts",
    notes: ["Redline, HSV and Brembo cars need brake clearance checks.", "Staggered 20s and selected 22s are common EA enquiries."]
  }
];

const GOALS = [
  {
    id: "safe",
    label: "Daily street fit",
    short: "Good looking wheels that are easy to live with.",
    description: "Best for someone who wants the car to look sharper without making it hard to drive every day. EA keeps the advice around sensible width, sensible offset, easy tyre sizing and less chance of rubbing."
  },
  {
    id: "stance",
    label: "Tough street stance",
    short: "A stronger look without going full custom.",
    description: "Best for someone who wants the car sitting tougher on the road. EA can guide wheel width, tyre profile and offset so it gets a stronger presence while still staying practical."
  },
  {
    id: "walky",
    label: "Walky / Walkinshaw",
    short: "Walky-style Commodore fitment with EA guidance.",
    description: "Best for customers chasing the Walky or Walkinshaw-inspired look. EA checks size, finish, offset, tyre choice, brake clearance and whether the wheel is a style finish or a confirmed multi-piece construction."
  },
  {
    id: "deep",
    label: "Deep dish / lip",
    short: "More wheel lip and a deeper rear look.",
    description: "Best for customers chasing dish, lip or a more old-school tough Commodore look. EA pays extra attention to rear offset, tyre shoulder, guard clearance and suspension height."
  },
  {
    id: "staggered",
    label: "Staggered setup",
    short: "Wider rear wheels than front wheels.",
    description: "Best for someone who wants a performance-style stance with more rear width. EA checks front and rear tyre pairing, rolling diameter, brake clearance and rear guard room."
  }
];

const WHEEL_SIZES = [
  { id: "18", label: "18 inch", tyre: "245/40R18", note: "Reference only for Commodore factory-style comparison. EA's main Commodore sales focus is 20 and 22 inch." },
  { id: "19", label: "19 inch", tyre: "245/35R19", note: "Reference only for selected factory-style Commodore and HSV comparison. EA's main Commodore sales focus is 20 and 22 inch." },
  { id: "20", label: "20 inch", tyre: "245/35R20", note: "EA's strongest Commodore wheel package path and the main street fitment recommendation." },
  { id: "22", label: "22 inch", tyre: "245/30R22", note: "EA's show-style Commodore path with extra tyre, guard and ride-height guidance." }
];

const WALKY_FAMILY = {
  title: "EA Walky / Walkinshaw-style fitment family",
  summary: "A dedicated Commodore path for customers asking about Walky, Walkinshaw-style, machined-lip, deep dish or heritage HSV-inspired wheels.",
  constructionNote: "Some EA listings describe Flowform, Fusion Forged or machined-lip finishes. Do not call a wheel true 2-piece or 3-piece unless the exact product listing confirms that construction.",
  sizes: [
    { size: "20x8.5", role: "Safer front or square direction", tyre: "Commonly discussed around 245/35R20", risk: "Common check" },
    { size: "20x9.5", role: "Rear or staggered direction", tyre: "Often paired with 255/35R20 or 275/30R20 depending car", risk: "Needs offset and guard check" },
    { size: "20x10", role: "Aggressive rear / deep dish direction", tyre: "Tyre choice depends on rear guard and ride height", risk: "EA confirmation needed" },
    { size: "22x8", role: "Show fit square direction", tyre: "245/30R22 is a common comparison size", risk: "Ride height and load rating check" },
    { size: "22x9", role: "Show fit / stronger rear stance", tyre: "245/30R22 or similar only after checking clearance", risk: "EA confirmation needed" }
  ]
};

const EA_PRODUCTS = [
  {
    title: "WALKIN Fusion Forged | HSV VL SS Group A Walky Remastered",
    fit: "VL HSV Walky heritage",
    family: "walky",
    image: "https://cdn.shopify.com/s/files/1/0648/3325/7546/files/WALKIN.jpg?v=1778283915",
    notes: "Heritage Walky direction. Confirm exact model, brake package and construction details before sale."
  },
  {
    title: "WALKY 20x8.5 Gloss Silver Machined Lip",
    fit: "Holden Commodore Walky fitment family",
    family: "walky",
    image: "https://cdn.shopify.com/s/files/1/0648/3325/7546/files/WALKY_20x8.5_-_GLOSS_SILVER_MACHINED_LIP_03.05.2026.png?v=1777856762",
    notes: "Useful safer-width Walky starting point. Good for square or front fitment discussions."
  },
  {
    title: "WALKY 20x9.5 MX Grey Machined Lip",
    fit: "Holden Commodore Walky fitment family",
    family: "walky",
    image: "https://cdn.shopify.com/s/files/1/0648/3325/7546/files/WALKY_20x9.5_-_MX_GREY_MACHINED_LIP_03.05.2026_2.png?v=1777851714",
    notes: "Staggered rear direction. Confirm offset, rear guard room and tyre size."
  },
  {
    title: "WALKY 20x10 Gloss Silver Machined Lip",
    fit: "Holden Commodore Walky fitment family",
    family: "walky",
    image: "https://cdn.shopify.com/s/files/1/0648/3325/7546/files/WALKY_20x10_-_GLOSS_SILVER_MACHINED_LIP_04.05.2026_2.png?v=1777845504",
    notes: "Aggressive deep dish rear path. Treat as an EA confirmation fitment."
  },
  {
    title: "WALKY 22x9 Gloss Silver Machined Lip",
    fit: "Holden Commodore Walky 22 inch show path",
    family: "walky",
    image: "https://cdn.shopify.com/s/files/1/0648/3325/7546/files/WALKY_22x9_-_GLOSS_SILVER_MACHINED_LIP_03.05.2026.png?v=1777850963",
    notes: "22 inch Walky show direction. Confirm tyre load rating, guards and ride height."
  },
  {
    title: "WALKY WS 20 inch Silver Machined Lip",
    fit: "Holden Commodore Walky WS",
    family: "walky",
    image: "https://cdn.shopify.com/s/files/1/0648/3325/7546/files/RSERIES_WALLKY_WS_SILVER_MACHINED_LIP_20_HOLDEN_WHEELS_21.webp?v=1773557240",
    notes: "Walky WS option from EA listings. Verify exact width and offset from product page before final recommendation."
  },
  {
    title: "GTSR Style 20 inch Staggered Wheels | Holden Commodore",
    fit: "VT VX VY VZ VE VF",
    family: "general",
    image: "https://cdn.shopify.com/s/files/1/0648/3325/7546/files/V-1014_Gtsr_fully_polished_20x8.5_20x9.5_Suit_all_commodores_and_has_big_brake_clearance_11.png?v=1777638033",
    notes: "Good sales example for staggered 20 inch Holden enquiries."
  },
  {
    title: "GTS Rimfire LSA Style 20 inch Staggered Wheels",
    fit: "VT VX VY VZ VE VF",
    family: "general",
    image: "https://cdn.shopify.com/s/files/1/0648/3325/7546/files/V_1016_0_GTS_rimfire_Lsa_6.2.png?v=1777676085",
    notes: "Use for HSV-inspired Commodore fitment discussions."
  },
  {
    title: "Inflexion Style 20 inch Staggered Wheels",
    fit: "VE VF",
    family: "general",
    image: "https://cdn.shopify.com/s/files/1/0648/3325/7546/files/V-1007_New_20_Holden_inflextions_silver_or_hyper_black_20x8.5_20x9.5_suit_commodores_1.1.png?v=1777601934",
    notes: "Strong VE/VF daily-to-sport upgrade example."
  },
  {
    title: "R8 HSV Style 22x9 Gloss Black Set",
    fit: "VE VF",
    family: "general",
    image: "https://cdn.shopify.com/s/files/1/0648/3325/7546/files/S-2004_BrandNew22INCHR8HSVSetStyleWheelsFitVFVEFULLGLOSSBLACK_2.png?v=1777341520",
    notes: "Show fit path. Confirm tyre size, ride height and guards."
  },
  {
    title: "Tri Spoke Style 20x8 Wheels",
    fit: "VT VX VY VZ VE VF",
    family: "general",
    image: "https://cdn.shopify.com/s/files/1/0648/3325/7546/files/S-2013_20_HSV_Tri-Spoke_Style_Wheels_Gloss_Black_0.png?v=1777364986",
    notes: "Square 20 inch option for simpler rotation and tyre matching."
  },
  {
    title: "Momo Star Style 20 inch Deep Dish Staggered Wheels",
    fit: "VL VT VX VY VZ VE VF",
    family: "general",
    image: "https://cdn.shopify.com/s/files/1/0648/3325/7546/files/S-2026_20MomoStarStyleWheels_TyresforHoldenCommodoreVLVTVXVYVZVEVF_2_341c4f09-c144-49a2-ad16-b0eb5eab0148.png?v=1777362321",
    notes: "Deep dish direction. Needs rear clearance and tyre confirmation."
  }
];
